import React, { useState } from 'react';

import { isAudio } from '~/src/components/MediaPlayer';
import { MoreInfoPopover } from '~/src/components/MoreInfoPopover';

import type { Content } from '../types';

import { HeroMedia } from './HeroMedia';

interface Props {
  content: Content;
}

export const Hero: React.FC<Props> = ({ content }) => {
  const [isMoreInfoOpened, setIsMoreInfoOpened] = useState(false);

  return (
    <>
      <HeroMedia content={content} />
      <MoreInfoPopover
        isAudio={isAudio(content)}
        open={isMoreInfoOpened}
        description={content.snippet}
        props={('props' in content && content.props) || null}
        handleDismiss={() => setIsMoreInfoOpened(false)}
      />
    </>
  );
};
